import '@mdi/font/css/materialdesignicons.css'
import axios, { AxiosError } from 'axios'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import Notifications from 'vue-notification'
import App from './App.vue'
import generateVuetify from './plugins/vuetify'
import { generateVueRoute } from './router'
import store from './store'

Vue.use(VueCookies)

import './filters'

import { Loader } from '@googlemaps/js-api-loader'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import sanitizeHtml from 'sanitize-html'
import './assets/global.scss'
import { accountService } from './services'
import { generateAPIUrl } from './utils'


axios.interceptors.response.use(function(response) {
        return response
    }, async function(error: AxiosError) {
        if(error.response?.status == 401 && !(error?.config?.url ?? '').includes('Redirecter')) {
            await store.dispatch('logout', false)
            const redirectUrl = await accountService.Redirecter(window.location.href)
            // Change this afterwards to Microsoft, when we need to login via SSO
            const params = new URLSearchParams(window.location.search)
            const domainHint = params.get('domain_hint') || 'none'

            if(redirectUrl) {
                window.location.href = `${redirectUrl}&domain_hint=${domainHint}`
            } else {
                await store.dispatch('forbidUser', true)
            }
        }

        if(error.response?.status == 403) {
            await store.dispatch('forbidUser', true)
        }

        return Promise.reject(error)
})
    

Vue.use(VueAxios, axios)
Vue.use(Notifications)
dayjs.extend(customParseFormat)

const windowReference = (window as any)
if (windowReference.trustedTypes && windowReference.trustedTypes.createPolicy) { // Feature testing
    windowReference.trustedTypes.createPolicy('default', {
        createHTML: (string: string) => sanitizeHtml(string, {
            allowedTags: sanitizeHtml.defaults.allowedTags.concat([
                'svg', 'path'
            ]),
            allowedAttributes: {
                ...sanitizeHtml.defaults.allowedAttributes,
                svg: ['xmlns', 'class', 'width', 'height', 'viewBox', 'stroke-width', 'stroke', 'fill', 'stroke-linecap', 'stroke-linejoin'],
                path: ['d', 'fill', 'stroke', 'stroke-width']
            },
        }),
        createScriptURL: (string: string) => string,
        createScript: (string: string) => string,
    })
}
async function renderApp() {
    // @ts-ignore
    axios.defaults.mode = 'cors'
    axios.defaults.baseURL = generateAPIUrl()
    axios.defaults.withCredentials = true

    Vue.config.productionTip = false
    const vuetify = await generateVuetify()

    await store.dispatch('getUserInfo')
    await store.dispatch('getConfig')
    const loader = new Loader({
            apiKey: store.getters.config.gk ?? '',
            version: '3.54',
            libraries: ['core', 'places', 'drawing']
    })

    // await loader.importLibrary('core')
    // await loader.importLibrary('places')
    // await loader.importLibrary('drawing')
    await loader.load()

    const { router, routes } = await generateVueRoute()
    store.dispatch('updateRoutes', routes)


    new Vue({
        store,
        vuetify,
        router,
        render: h => h(App)
    }).$mount('#app')

}

renderApp()
